// to set the current year
export function currentYear() {
  return new Date().getFullYear();
}

export function getYear() {
  if (document.getElementById('year')) {
    const year = currentYear();
    document.getElementById('year').innerHTML = year;
    return year;
  }
  return null;
}
